export const UNSUPPORTED_DEEPLINKS_METADATA = [
  { sourcePath: 'activity-list', metaTitle: 'Check out the latest activity in the Fishbrain app' },
  { sourcePath: 'bite-times', metaTitle: 'Check out current bite times in the Fishbrain app' },
  { sourcePath: 'campaigns', metaTitle: 'Check out this offer in the Fishbrain app' },
  { sourcePath: 'email-collection', metaTitle: 'Update your email on Fishbrain' },
  { sourcePath: 'friends', metaTitle: 'Find friends on Fishbrain' },
  { sourcePath: 'fish-id', metaTitle: 'Identify your fish on Fishbrain' },
  { sourcePath: 'group-chat', metaTitle: 'Check out messages on Fishbrain' },
  { sourcePath: 'group-chats', metaTitle: 'Check out messages on Fishbrain' },
  { sourcePath: 'partner-promotions', metaTitle: 'Check out this offer on Fishbrain' },
  { sourcePath: 'quick-sign-in', metaTitle: 'Sign in on Fishbrain' },
  { sourcePath: 'user-referral', metaTitle: 'Invite friends to Fishbrain' },
  {
    sourcePath: 'user-referral-premium',
    metaTitle: 'Invite friends to Fishbrain to get an exclusive pro offer',
  },
  { sourcePath: 'settings', metaTitle: 'Update your settings in the Fishbrain app' },
  { sourcePath: 'share-profile', metaTitle: 'Share your profile in the Fishbrain app' },
  { sourcePath: 'statistics', metaTitle: 'Check out your statistics in the Fishbrain app' },
  { sourcePath: 'system-settings', metaTitle: 'Go to phone settings' },
  { sourcePath: 'tacklebox', metaTitle: 'Check out your tacklebox in the Fishbrain app' },
  { sourcePath: 'top-baits', metaTitle: 'Check out top baits in the Fishbrain app' },
  { sourcePath: 'weather', metaTitle: 'Check out latest weather forecast on Fishbrain' },
  { sourcePath: 'following-species', metaTitle: 'Check out species you follow on Fishbrain' },
  {
    sourcePath: 'water-card-specie',
    metaTitle: 'Check out this fishing water on Fishbrain',
  },
];
